import {
  TX_RESTART_SUCCESS,
  TX_RESTART_REQUEST,
  TX_RESTART_FAILURE,
  TX_RESTART_RESET,
} from '../actions/transaction_restart'

export const transactionRestart = (
  state = {
    isFetching: false,
    results: null,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case TX_RESTART_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }

    case TX_RESTART_SUCCESS:
      return {
        ...state,
        isFetching: false,
        results: action.response,
        errorMessage: null,
      }
    case TX_RESTART_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    case TX_RESTART_RESET:
      return { ...state, isFetching: false, errorMessage: null }
    default:
      return state
  }
}
